module.exports = __webpack_public_path__ + "static/media/instagram.0335eb2a.png";